export default __webpack_public_path__ + "static/media/op.62e4c6c1.svg";